import { useCallback, useEffect, useState } from 'react';
import { callAPI } from '../utils/apiUtils';
import { apiUrls } from '../utils/apiUrls';

const REFRESH_MS = 60 * 1000;

// Live set of product ids currently sold out (their own flag, or their category's / sub-category's).
// The ordering screen renders from a locally cached menu that only changes on "Sync Menu", which is
// too stale for something staff flip mid-service and expect every terminal to respect - so this
// small list is fetched on top of it: on mount, every minute, and when the window regains focus.
// Keeps the last known set if a refresh fails (offline blip) rather than un-greying everything.
const useSoldOutIds = () => {
  const [soldOutIds, setSoldOutIds] = useState(() => new Set());
  // productId -> units left, for stock-tracked products (empty while the restaurant has tracking off)
  const [stockLevels, setStockLevels] = useState({});

  const refresh = useCallback(async () => {
    try {
      const res = await callAPI(apiUrls.PRODUCT_MANAGEMENT_SOLD_OUT, {}, 'GET', null, {}, {}, false);
      setSoldOutIds(new Set((res.data?.data?.product_ids || []).map(Number)));
      setStockLevels(res.data?.data?.stock || {});
    } catch (err) {
      console.error('Failed to refresh sold out items', err);
    }
  }, []);

  useEffect(() => {
    refresh();
    const timer = window.setInterval(refresh, REFRESH_MS);
    window.addEventListener('focus', refresh);
    return () => {
      window.clearInterval(timer);
      window.removeEventListener('focus', refresh);
    };
  }, [refresh]);

  return { soldOutIds, stockLevels, refreshSoldOut: refresh };
};

export default useSoldOutIds;
